import { RequestStepTaskTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { BlockTask } from '../../workflow-engine/utils/blocks'

export const isSummaryApprovalBlock = (tasks?: readonly Pick<BlockTask, 'type'>[] | null) => {
  if (!tasks || tasks.length === 0) {
    return false
  }

  return Boolean(tasks?.every((task) => task.type === RequestStepTaskTypeEnum.SUMMARY_APPROVAL))
}
